module.exports = __webpack_public_path__ + "img/info.ae71806b.svg";